import Vue from 'vue'
import store from '@/store/store'

import { AnchorConditions, Conditions } from '@/modules/class/PdfDownload/Conditions'
import PdfDownloadList from './PdfDownloadList.vue'
import PdfDownloadListWithImage from './PdfDownloadListWithImage.vue'
import PdfDownloadTable from './PdfDownloadTable.vue'
import PdfDownloadTableFull from './PdfDownloadTableFull.vue'
import PdfDownloadTableAnchor from './PdfDownloadTableAnchor.vue'

// 翻訳
import VueI18n from 'vue-i18n'
import Translate from './translation/Translate'
Vue.use(VueI18n)
const i18n = new VueI18n(Translate)

// Download Listを複数設置
const lists = document.querySelectorAll('vue.js-pdfDownloadList')
for (const item of lists) {
  if (item instanceof HTMLElement) {
    try {
      // 抽出条件を取得
      const conditions = Conditions.crate(JSON.parse(item.textContent ?? '{}'))

      const vm = new Vue({
        i18n,
        store,
        render: h => h(PdfDownloadList)
      }).$mount(item)

      // 抽出条件をリアクティブデータにセット
      vm.$set(vm.$children[0], 'conditions', conditions)
    } catch (error) {
      console.error(error)
      continue
    }
  }
}

// Image付きのDownload Listを複数設置
const imageLists = document.querySelectorAll('vue.js-pdfDownloadListWithImage')
for (const item of imageLists) {
  if (item instanceof HTMLElement) {
    try {
      // 抽出条件を取得
      const conditions = Conditions.crate(JSON.parse(item.textContent ?? '{}'))

      const vm = new Vue({
        i18n,
        store,
        render: h => h(PdfDownloadListWithImage)
      }).$mount(item)

      // 抽出条件をリアクティブデータにセット
      vm.$set(vm.$children[0], 'conditions', conditions)
    } catch (error) {
      console.error(error)
      continue
    }
  }
}

// Download Tableを複数設置
const tables = document.querySelectorAll('vue.js-pdfDownloadTable')
for (const item of tables) {
  if (item instanceof HTMLElement) {
    try {
      // 抽出条件を取得
      const conditions = Conditions.crate(JSON.parse(item.textContent ?? '{}'))

      const vm = new Vue({
        i18n,
        store,
        render: h => h(PdfDownloadTable)
      }).$mount(item)

      // 抽出条件をリアクティブデータにセット
      vm.$set(vm.$children[0], 'conditions', conditions)
    } catch (error) {
      console.error(error)
      continue
    }
  }
}

// Download Tableを複数設置
const fullTables = document.querySelectorAll('vue.js-pdfDownloadTableFull')
for (const item of fullTables) {
  if (item instanceof HTMLElement) {
    try {
      // 抽出条件を取得
      const conditions = Conditions.crate(JSON.parse(item.textContent ?? '{}'))

      const vm = new Vue({
        i18n,
        store,
        render: h => h(PdfDownloadTableFull)
      }).$mount(item)

      // 抽出条件をリアクティブデータにセット
      vm.$set(vm.$children[0], 'conditions', conditions)
    } catch (error) {
      console.error(error)
      continue
    }
  }
}

// テーブルが存在する場合、ページ内リンクを作成する
if (fullTables) {
  const anchor = document.querySelector('vue#vue_pdf_download_anchor')
  if (anchor) {
    try {
      const conditions = AnchorConditions.crate(JSON.parse(anchor.textContent ?? '{}'))

      const vm = new Vue({
        i18n,
        store,
        render: h => h(PdfDownloadTableAnchor)
      }).$mount('#vue_pdf_download_anchor')

      // 抽出条件をリアクティブデータにセット
      vm.$set(vm.$children[0], 'conditions', conditions)
    } catch (error) {
      console.error(error)
    }
  }
}
